export function calcMapInstanceId(mapDomId: string, instanceNumber: number) {
  return `${instanceNumber}_${mapDomId}`;
}
